import React, { useState,useEffect } from 'react'
import {  MDBRow, MDBCol,MDBInput, MDBBtn
    , } from 'mdbreact';

    import { MDBCard, MDBCardBody, MDBCardHeader, MDBCardFooter  } from "mdbreact";


    
import Axios from 'axios';
    
import DatePicker from "react-datepicker";
    
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import WarningBox from '../components/WarningBox';
import AccessDenied from '../components/AccessDenied';


const Reports=(props)=> {
    const useMountEffect = (functionName) => useEffect(functionName, [])
  
    const serverURL=props.apiServer;

 const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }


  const [frm, setValues] = useState({
    reporttype:'',
    datefrom: new Date(),
    dateto: new Date(),
 
    username:sessionStorage.getItem("msal.uc")
   

  });
  

 
  const [errorMessage,setErrorMessage]=useState("");

  

const notify = message  => {
    toast(message);
}

const [modalWarning,showWarningBox]=useState(false);
  

  
const toggleWarningBox = () => {
  showWarningBox(!modalWarning);

  }


  const getDateValue = dtPickerName =>(actualValue)=>{

    setValues({ ...frm, [dtPickerName]:actualValue});

} 



const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;

      setValues({ ...frm, [name]: value });
    }
    else
    {
      setValues({ ...frm, [name]: value });
    }

   

};
  
  const  handleChange = objName => (selOption) => {
  
    setValues({ ...frm, [objName]: selOption });
   
 };

 
 const [reporttypeOptions, setreporttypeOptions] = useState([]);

 const loadreporttypelist=()=>
 {
   


   Axios.get(serverURL + '/getreporttypeoptions',bearer)
       .then(res => {
        
         setreporttypeOptions(res.data);
          
         
       })
 
       .catch(error => {
         setErrorMessage(error);
          console.log(error);
       
       }
   );  
 }

 const loadreporttypelistadmin=()=>
 {
   

  
   Axios.get(serverURL + '/getreporttypeoptionsadmin',bearer)
       .then(res => {
        
         setreporttypeOptions(res.data);
          
         
       })
 
       .catch(error => {
         setErrorMessage(error);
          console.log(error);
       
       }
   );  
 }

 
 const loadreporttypelistsuperadmin=()=>
 {
   

  
   Axios.get(serverURL + '/getreporttypeoptionssuperadmin',bearer)
       .then(res => {
        
         setreporttypeOptions(res.data);
          
         
       })
 
       .catch(error => {
         setErrorMessage(error);
          console.log(error);
       
       }
   );  
 }

 function padTo2Digits(num) {
  return num.toString().padStart(2, '0');
}
 function formatDate(date) {
  return [
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
    
    date.getFullYear(),
  ].join('/');
}

 function submitHandler (event){
    event.preventDefault();
    event.target.className += " was-validated"; 
    
   GenerateReport();
   
}

function GenerateReport()
{

 console.log(frm.reporttype["value"]);
 window.open(props.apiServerHybrid + 'Print/ReportGeneration?reporttype=' + frm.reporttype["value"] + '&code=none&dtFrom=' + formatDate(new Date(frm.datefrom.toLocaleDateString('en-US'))) + '&dtTo=' + formatDate(new Date(frm.dateto.toLocaleDateString('en-US'))) + '&processedby=' + sessionStorage.getItem('msal.uc'),"_blank");
}

//  function submitHandler (event){
//     event.preventDefault();
//     event.target.className += " was-validated"; 
    
//    GenerateReport();
   
// }

// function GenerateReport()
// {

//  console.log(frm.reporttype["value"]);
//  window.open(props.apiServerHybrid + 'Print/ReportGeneration?reporttype=' + frm.reporttype["value"] + '&code=none&dtFrom=' + frm.datefrom.toLocaleDateString('en-US') + '&dtTo=' + frm.dateto.toLocaleDateString('en-US'),"_blank");
// }


  


 
const [isReportAccess,setReportAccess]=useState(0);
    
function checkReportAccess() {
      
  
  Axios.get(props.apiServer + "/getreportaccess?username=" + sessionStorage.getItem("msal.uc") ,bearer)
   .then(res => {
   
    setReportAccess(0);
    setReportAccess(res.data[0].roleid);
 
      setPreloader("none");
   })
 
   .catch(error => {
    
    console.log(error);
   });  
  
 
 
 
 }

 useMountEffect(checkReportAccess);


 useEffect(() => {


   if(isReportAccess=='systemadministrator')
   {
    loadreporttypelistsuperadmin();
   }
   else if(isReportAccess=='administrator')
   {
    loadreporttypelistadmin();
   }
   else
   {
    loadreporttypelist();
  
   }
  
},[isReportAccess]);





// if( isAdmin==0 ) 
// {

//   return (
//     <React.Fragment>
//       <AccessDenied />
       

//     </React.Fragment>
   
    
//     );
// }
  
 



/* eslint-disable */

    return (
       <React.Fragment>
   <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
       
     
<MDBCard className="w-100 mt-5">
   
    <MDBCardBody>
     
   <MDBRow>
     <MDBCol md="12">
     <h6  style={{fontFamily:"Montserrat",fontWeight:"400"}} className="display-5 blue-grey-text ml-1 mb-3"> REPORTS GENERATION</h6>
                   
     </MDBCol>
   </MDBRow>
    <MDBRow hidden >
                       <MDBCol md="12">

                       <MDBInput  
                            hidden
                            value={frm.username} 
                            id="username"  
                            label="username" 
                            >
                                <div className="invalid-feedback">
                                This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                       </MDBCol>

                       
                      
                   </MDBRow>
                
                    <MDBRow>
                        <MDBCol md="6" className="text-left">
                        <label className="grey-text"><small>&nbsp;Type of Report</small></label>
                        {/* <p>{isReportAccess}</p> */}
                        </MDBCol>

                        <MDBCol md="6" className="text-left">
                       
                        </MDBCol>

                   </MDBRow>

                   <MDBRow>
                        <MDBCol md="6" className="text-left">
                            
                         <Select
                            placeholder="Select type of report to generate"
                            isSearchable
                            value={frm.reporttype}
                            onChange={handleChange("reporttype")}
                            options={reporttypeOptions}
                            required/>
 
                            <div className="invalid-feedback">
                                 This field is required!
                            </div>
                                 <div className="valid-feedback">Looks good!</div>
                        
                        <br/>
                        </MDBCol>

                        <MDBCol md="6" className="text-left">
                               
                        </MDBCol>

                   </MDBRow>
                  


              
                   <MDBRow  hidden>
                       <MDBCol md="12">
                       <MDBInput  
                      
                      
                      id="wholemonth" 
                      label="Whole Month" 
                      type="checkbox"
                      checked={frm.wholemonth}
                      onChange={updateField}
                      
                     >
                      
                          <div className="invalid-feedback">
                          This field is required!
                      </div>
                      <div className="valid-feedback"></div>

                  </MDBInput>
                      
                       </MDBCol>

                       
                      
                   </MDBRow>

                   <MDBRow>
                        <MDBCol md="4" className="text-left">
                        <label className="grey-text"><small>&nbsp; From</small></label>
                      

                        </MDBCol>

                        <MDBCol md="4" className="text-left">
                        <label className="grey-text"><small>&nbsp;To</small></label>
                      
                        </MDBCol>
                    </MDBRow>
                    <MDBRow>
                        <MDBCol md="4" className="text-left">
                        
                        <DatePicker
                        
                        
                        selected={frm.datefrom}
                         onChange={getDateValue("datefrom")}  
                            
                        />
                        <br/><br/>
                        </MDBCol>

                        <MDBCol md="4" className="text-left">
                        
                        <DatePicker
                        
          
                        selected={frm.dateto}
                         onChange={getDateValue("dateto")}  
                            
                        />
                        <br/><br/>
                        </MDBCol>
                    </MDBRow>



                    <MDBRow>
                       
                    <MDBCol md="8" className="text-left">
             
                 
                
                        <MDBBtn type="submit"  color="primary">
                       Generate Report
                        </MDBBtn> 
                        </MDBCol>
                       <MDBCol md="4">


                     
                       </MDBCol>
                      
                    </MDBRow>
   
                

                
                   

                   
                   
                   

                  
                 
                  
                  
                
                   

    </MDBCardBody>
    <MDBCardFooter>
    
                               
    </MDBCardFooter>
   
  </MDBCard>

  <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />


  </form>

  

                <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>

                </React.Fragment>    
    )
}

export default Reports
